import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "section-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "section-content"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionWrapper',
  props: {
  title: String,
  isCollapsed: Boolean,
  isDragging: Boolean,
  isDisabled: Boolean,
  showCloseButton: Boolean,
},
  emits: ["toggle", "close"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const toggle = () => {
  emit("toggle");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["section-header", {
        'is-dragging': __props.isDragging,
        'grab-cursor': !__props.isDisabled,
        disabled: __props.isDisabled,
      }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (!__props.isDisabled ? toggle() : null))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "grip-icon" }, "⠿", -1)),
      _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
      (__props.showCloseButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "close-button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"])),
            title: "Sulje"
          }, " × "))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["collapse-icon", { disabled: __props.isDisabled }])
          }, _toDisplayString(__props.isCollapsed ? "▶" : "▼"), 3))
    ], 2),
    (!__props.isCollapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})